<template>
  <form class="tui ui form" @submit.prevent="sendCampaign(campaign)">
    <div class="tui form-field" :class="[{'error' : $v.campaign.name.$error}, {'error' : error.count}]">
      <label for="nameCampaign">Nome da campanha</label>
      <input id="nameCampaign" v-model.trim="$v.campaign.name.$model" maxlength="50" name="nameCampaign" type="text" placeholder="Digite" class="name-campaign" @keyup="countdown" />
      <span class="count-input">{{ remainingCount }}/50</span>
      <small v-if="!$v.campaign.name.required" class="error">O campo nome é obrigatório</small>
      <small v-if="!$v.campaign.name.minLength" class="error">O campo nome deve conter no mínimo {{$v.campaign.name.$params.minLength.min}} caracteres.</small>
    </div>

    <div class="fields">
      <div class="tui ten wide field form-field" :class="[{'error' : $v.campaign.value.$error}, {'error' : error.minValue}]">
        <label for="value">Valor da mala/Recorrência</label>
        <div class="wrap-tootip">
          <div class="tooltip-content right" data-tooltip="O valor mínimo para doação é de R$ 10,00." data-position="right center">
            <t-icon class="tooltip-icon" :icon="['fal', 'info-circle']" />
          </div>
        </div>
        <div class="ui right labeled input">
          <input v-model="$v.campaign.value.$model" v-money="campaign.value !== null ? money : null"  type="text" placeholder="R$ 10,00">
          <sui-dropdown
            v-model="current"
            class="dropdown-frequency"
            :options="frequency"
            placeholder="Doação"
            selection
          />
        </div>
        <small v-if="!$v.campaign.value.required" class="error">O campo Valor é obrigatório</small>
        <small v-if="!$v.current.required" class="error">O campo Recorrência é obrigatório</small>
        <small v-if="error.minValue" class="error">O Valor mínimo é de R$ 10,00.</small>
      </div>

      <div class="tui six wide field form-field" :class="[{'error' : $v.campaign.dueDate.$error}, {'error' : error.minDueDate}]">
        <label for="dueDate">Vencimento</label>
        <div class="wrap-tootip">
          <div class="tooltip-content right" data-tooltip="O recebimento do boleto pode variar de acordo com cada estado, sugirimos que coloque o prazo de vencimento com intervalo de 10 à 15 dias." data-position="right center">
            <t-icon class="tooltip-icon" :icon="['fal', 'info-circle']" />
          </div>
        </div>
        <input v-model="campaign.dueDate" v-mask="['##/##/####']" type="text" name="dueDate" placeholder="__/__/____">
        <small v-if="!$v.campaign.dueDate.invalid" class="error">O campo Vencimento é obrigatório</small>
        <small v-if="!$v.campaign.dueDate.dateFormat" class="error">Data inválida</small>
        <small v-if="error.minDueDate" class="error">A Data não pode ser menor a de hoje</small>
      </div>
    </div>

    <div v-if="false" class="tui form-field">
      <label>Descrição do boleto</label>
      <textarea v-model="campaign.message" rows="4" spellcheck="true" maxlength="450" placeholder="Mensagem"></textarea>
      <span class="count-input">10/450</span>
    </div>

    <div class="tui form-field">
      <label for="meta">Meta</label>
      <input id="meta" v-model.trim="campaign.goalValue" v-money="campaign.goalValue !== null ? money : null" name="meta" type="text" placeholder="R$ 35.000,00" class="name-campaign" />
    </div>

    <div v-if="organization.exportGuara" class="tui form-field">
      <label for="idGuara">Campanha do Guará</label>
      <input id="idGuara" v-model.trim="campaign.idGuara" name="idGuara" type="text" placeholder="Digite o ID da campanha do Guará" class="name-campaign" />
    </div>

    <div v-if="organization.exportGuara" class="tui form-field" :class="[{'error' : error.countGroup}]">
      <label for="grupoGuara">Grupo do Guará</label>
      <input id="grupoGuara" v-model.trim="campaign.guaraCampaignGroup" name="grupoGuara" type="text" placeholder="Digite o grupo da campanha do Guará" class="name-campaign" @keyup="countdownGroup" />
      <span class="count-input">{{ remainingCountGroup }}/50</span>
    </div>

    <div class="tui form-field right aligned">
      <button :class="`tui ui button primary ${isLoading ? 'loading disabled' : ''}`" :disabled="isLoading || this.$v.$invalid">
        Salvar
      </button>
    </div>
  </form>
</template>

<script>
import gql from 'graphql-tag'
import { VMoney } from 'v-money'
import { mapGetters } from 'vuex'
import { required, minLength, helpers } from 'vuelidate/lib/validators'
const dateFormat = helpers.regex('dateFormat', /^(0[1-9]|[12]\d|3[01])[\/](0[1-9]|1[0-2])[\/](19|20)\d{2}$/g) // eslint-disable-line

export default {
  directives: { money: VMoney },
  data () {
    return {
      isLoading: false,
      remainingCount: 0,
      remainingCountGroup: 0,
      current: null,
      campaignSend: {},
      frequency: [
        { key: 'once', value: 'once', text: 'Única' },
      ],
      error: {
        minValue: false,
        minDueDate: false,
        count: false,
        countGroup: false
      },
      campaign: {
        name: null,
        value: null,
        frequency: null,
        dueDate: null,
        goalValue: null,
        idGuara: null,
        guaraCampaignGroup: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2
      }
    }
  },

  validations: {
    campaign: {
      name: {
        required,
        minLength: minLength(4)
      },
      value: {
        required
      },
      dueDate: {
        required,
        dateFormat
      }
    },
    current: {
      required
    }
  },

  computed: {
    ...mapGetters({
      organization: 'getOrganization'
    })
  },

  mounted () {
    this.$store.commit('breadcrumb/SET_TITLE_BREADCRUMB', 'Nova campanha')
    this.$store.commit('campaign/SET_DATA_CAMAPAIGN', null)
  },

  methods: {
    countdown () {
      this.remainingCount = this.campaign.name.length
      this.error.count = this.remainingCount === 50
    },

    countdownGroup () {
      this.remainingCountGroup = this.campaign.guaraCampaignGroup ? this.campaign.guaraCampaignGroup.length : 0
      this.error.count = this.remainingCountGroup === 50
    },

    sendCampaign (campaign) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.campaignSend.name = campaign.name
        this.campaignSend.value = this.formatAmout(campaign.value)
        this.campaignSend.frequency = this.current
        this.campaignSend.dueDate = this.checkDate(campaign.dueDate)
        if (this.organization.exportGuara) {
          this.campaignSend.guaraCampaignId = campaign.idGuara
          this.campaignSend.guaraCampaignGroup = campaign.guaraCampaignGroup
        }
        if (campaign.goalValue) {
          this.campaignSend.goalValue = this.formatAmout(campaign.goalValue)
        }
        this.createCampaign(this.campaignSend)
      }
    },

    formatAmout (amout) {
      let price = amout.replace(/\D/g, '')
      const number = parseFloat(price)
      if (number < 1000) {
        this.error.minValue = true
        return
      }
      this.error.minValue = false
      return number
    },

    checkDate (date) {
      var partesData = date.split("/");
      var data = new Date(partesData[2], partesData[1] - 1, partesData[0]);
      if(data < new Date()) {
        this.error.minDueDate = true
        this.$v.$invalid = true
        return
      }
      this.error.minDueDate = false
      return data.toISOString()
    },

    createCampaign (params = {}) {
      this.isLoading = true
      this.$api.mutate({
        mutation: gql`mutation createCampaign (
          $name: String
          $frequency: String
          $value: Int
          $dueDate: ISO8601Date
          $guaraCampaignId: String
          $guaraCampaignGroup: String
          $goalValue: Int
        ) {
          createCampaign (
            name: $name
            frequency: $frequency
            value: $value
            dueDate: $dueDate
            guaraCampaignId: $guaraCampaignId
            guaraCampaignGroup: $guaraCampaignGroup
            goalValue: $goalValue
           ) {
            campaign {
              id
            }
            error {
              message
              status
            }
          }
        }`,
        variables: params,
      })
      .then(res => {
        const { error } = res.data.createCampaign
        if (error !== null) {
          setTimeout( () => {
            this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
            this.$store.commit('statusBar/SET_TYPE_BAR', 'error')
            this.$store.commit('statusBar/SET_TITLE_BAR', 'Falha em cadastrar campanha!')
            this.isLoading = false
          }, 8000)
        } else {
          this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
          this.$store.commit('statusBar/SET_TYPE_BAR', 'success')
          this.$store.commit('statusBar/SET_TITLE_BAR', 'Campanha cadastrada com sucesso!')
          setTimeout( () => {
            this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
            this.$router.push('/home')
            this.isLoading = true
          }, 2000)
        }
      }).catch(e => {
        setTimeout( () => {
          this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
          this.$store.commit('statusBar/SET_TYPE_BAR', 'error')
          this.$store.commit('statusBar/SET_TITLE_BAR', 'Falha em cadastrar campanha!')
        }, 8000)
        this.isLoading = false
      })
    }
  }
}
</script>

<style src="./form-campaign.scss" lang="scss" scoped></style>
